// extracted by mini-css-extract-plugin
export var copyableField = "_n7-4";
export var customerBadge = "_n7-0";
export var customerInfoTitle = "_n7-2";
export var details = "_n7-1";
export var dropdownContainer = "_n7-5";
export var dropdownImage = "_n7-6";
export var editAssigneeForm = "_n7-a";
export var editButton = "_n7-3";
export var email = "_n7-7";
export var hidden = "_n7-d";
export var input = "_n7-8";
export var saveButton = "_n7-b";
export var shopifyIcon = "_n7-c";
export var suggestionBadge = "_n7-e";
export var suggestionText = "_n7-f";
export var username = "_n7-9";